module.exports = __webpack_public_path__ + "img/buildings.ffeecb08.jpg";